var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 18,
    viewBox: "0 0 75 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.936 17.136L7.536 9.6L5.04 11.808V17.136H0V0H5.04V6.528L12.096 0H18.048L10.968 6.504L18.696 17.136H12.936Z",
    fill: "#2C303B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8011 17.136L30.5051 13.944H22.6091L21.3371 17.136H16.2251L23.6891 0H29.5931L37.0571 17.136H31.8011ZM26.5691 3.984L24.0971 10.128H29.0411L26.5691 3.984Z",
    fill: "#2C303B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7458 17.136L41.0578 6.72V17.136H36.2578V0H40.7218L49.4098 10.416V0H54.2098V17.136H49.7458Z",
    fill: "#2C303B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9964 17.136L67.7004 13.944H59.8044L58.5324 17.136H53.4204L60.8844 0H66.7884L74.2524 17.136H68.9964ZM63.7644 3.984L61.2924 10.128H66.2364L63.7644 3.984Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanaDark);
export default __webpack_public_path__ + "static/media/kana-dark.56835b2876a690bac5005f185b74a127.svg";
export { ForwardRef as ReactComponent };